module.exports = __webpack_public_path__ + "static/media/Group 90.7ca6442a.png";